import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { WhyItFailed } from './components/WhyItFailed';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoItsFor } from './components/WhoItsFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { BuyersCompass } from './components/BuyersCompass';
import { OfferBlock } from './components/OfferBlock';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-offwhite selection:bg-amber/30 selection:text-forest" data-id="element-0">
      {/* Simple Header */}
      <header className="py-6 px-6 lg:px-8 flex justify-center border-b border-forest/5 bg-offwhite/80 backdrop-blur-md sticky top-0 z-50" data-id="element-1">
        <div className="text-forest font-serif text-2xl font-bold tracking-tight" data-id="element-2">
          Nutri-Sync
        </div>
      </header>

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Problem data-id="element-5" />
        <WhyItFailed data-id="element-6" />
        <Mechanism data-id="element-7" />
        <WhatYouGet data-id="element-8" />
        <WhoItsFor data-id="element-9" />
        <HowItWorks data-id="element-10" />
        <Proof data-id="element-11" />
        <FAQ data-id="element-12" />
        <BuyersCompass data-id="element-13" />
        <OfferBlock data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
    </div>;
}